module.exports = __webpack_public_path__ + "static/media/selfie-hand-disabled.ad0604b1.svg";